import { absCenter } from '../globalStyles';

export default {
  container: {
    position: 'relative',
  },
  resultContainer: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    marginTop: '1px',
    height: '300px',
    maxHeight: '300px',
    overflowY: 'auto',
    background: '#fff',
    boxShadow: '0 3px 8px rgba(0,0,0,0.24)',
    border: '1px solid rgba(0,0,0,0.18)',
    zIndex: 5,
  },
  itemBtn: {
    background: 'none',
    display: 'block',
    width: '100%',
    color: '#7a7a7a',
    borderBottom: '1px solid rgba(0,0,0,0.18)',
    padding: '5px',
    textAlign: 'left',
  },
  itemBtnHov: {
    background: 'rgba(0,0,0,0.02)',
  },
  btnTitle: {
    display: 'block',
    fontSize: '1.6rem',
  },
  btnText: {
    color: '#25262c',
    display: 'block',
    fontSize: '1.4rem',
  },
  content: {
    ...absCenter,
    fontSize: '1.6rem',
    textAlign: 'center',
  },
};
